import React from 'react';

import NOTES from './constants/notes.json';
import { HomePage } from './pages/home-page';
import { NotFoundPage } from './pages/not-found-page';
import { NoteViewPage } from './pages/note-view-page';

interface IRoute {
  path: string;
  exact?: boolean;
  title?: string;
  children?: Function;
}

export const ROUTES: IRoute[] = [
  {
    path: '/',
    exact: true,
    children: () => <HomePage />,
  },
  ...NOTES.map((note) => ({
    path: '/note/' + note.file,
    title: note.title,
  })),
  {
    path: '/note/:name',
    children: () => <NoteViewPage />,
  },
  {
    path: '*',
    children: () => <NotFoundPage />,
  },
];
